"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftExtend = require("draft-extend");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = require("immutable");

var _react = _interopRequireDefault(require("react"));

var DISPLAY_NAME = 'RemoveEmbeddedImagePlugin';
var EMBEDDED_IMAGE_REGEXP = /^data:image\//;
var EMBEDDED_IMAGE_TOAST_ID = 'EMBEDDED_IMAGE_TOAST_ID';

function addEmbeddedImageToast(options) {
  if (!(options && options.props && options.props.addToast)) {
    return;
  }

  options.props.addToast((0, _immutable.Map)({
    key: EMBEDDED_IMAGE_TOAST_ID,
    toast: (0, _immutable.Map)({
      textI18n: 'composer-plugins.embeddedImageToast.message',
      titleI18n: _react.default.createElement(_FormattedMessage.default, {
        message: "composer-plugins.embeddedImageToast.titleText"
      }),
      type: 'warning'
    })
  }));
}

var htmlToBlock = function htmlToBlock(options) {
  return function (nodeName, node) {
    if (nodeName === 'img' && EMBEDDED_IMAGE_REGEXP.test(node.src)) {
      addEmbeddedImageToast(options);
      return '';
    }

    return undefined;
  };
};

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _draftExtend.createPlugin)({
    displayName: DISPLAY_NAME,
    htmlToBlock: htmlToBlock(options)
  });
};

exports.default = _default;
module.exports = exports.default;